/**
 * Run days for the nightly review scan (TRA-1078).
 *
 * The API stores weekday names, Monday first, in the same order Python's
 * `date.weekday()` uses. The picker toggles one name at a time and always
 * sends the list back in that order, so the saved row and the settings
 * read never differ by order alone.
 */

export type RunDay = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'

export const RUN_DAYS: readonly RunDay[] = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun',
]

export const RUN_DAY_LABELS: Record<RunDay, string> = {
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
}

/** Add or remove one day; the result stays in weekday order. */
export function toggleRunDay(days: readonly RunDay[], day: RunDay): RunDay[] {
  const chosen = new Set(days)
  if (chosen.has(day)) {
    chosen.delete(day)
  } else {
    chosen.add(day)
  }
  return RUN_DAYS.filter((candidate) => chosen.has(candidate))
}

/** The message under the picker, or null when the selection can be saved. */
export function runDaysError(days: readonly RunDay[]): string | null {
  if (days.length === 0) {
    return 'Pick at least one day. To pause the scan, set the cap to 0.'
  }
  return null
}
